import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "development.icon",
  "use": "development.icon-usage",
  "viewBox": "-12055 -15990 18.041 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-12055 -15990 18.041 22\" id=\"development.icon\"><path d=\"M11.8,12.5v-1l1.1-.8a.367.367,0,0,0,.1-.3L12,8.7c-.1-.1-.2-.2-.3-.1L10.4,9a4.053,4.053,0,0,0-.9-.5L9.3,7.2c0-.1-.1-.2-.3-.2H7c-.1,0-.2.1-.3.2L6.5,8.5a4.053,4.053,0,0,0-.9.5L4.3,8.5a.367.367,0,0,0-.3.1L3,10.3c-.1.1,0,.2.1.3l1.1.8v1l-1.1.8a.756.756,0,0,0-.1.4l1,1.7c.1.1.2.2.3.1L5.7,15a4.053,4.053,0,0,0,.9.5l.2,1.3c-.1.1.1.2.2.2H9c.1,0,.2-.1.3-.2l.2-1.3a4.053,4.053,0,0,0,.9-.5l1.3.5a.367.367,0,0,0,.3-.1l1-1.7c.1-.1,0-.2-.1-.3l-1.1-.9ZM8,14a2,2,0,1,1,2-2A2.006,2.006,0,0,1,8,14ZM19,1H9A2.006,2.006,0,0,0,7,3V6H9V4H19V20H9V18H7v3a2.006,2.006,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V3A2.006,2.006,0,0,0,19,1Z\" transform=\"translate(-12057.959 -15991)\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/development.icon.svg
// module id = /xCq
// module chunks = 13